export class TrainerProfile {
  constructor () {
    this.id = null
    this.trainerId = ''
    this.baseLocation = ''
    this.traierCode = ''
    this.publicProfileUrl = ''
    this.linkedinProfileUrl = ''
    this.gitProfileUrl = ''
    this.stackoverflowProfileUrl = ''
    this.introVideoUrl = ''
    this.resumePrivateUrl = ''
    this.sampleTrainingVideoUrl = ''
    this.domainIndustry = ''
    this.summary = ''
    this.totalTrainingExperience = ''
    this.startedFreelancingYear = ''
  }
}



// WEBPACK FOOTER //
// ./src/models/TrainerProfile.js